// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullPageError_wrapper__JfNk5","action":"FullPageError_action__3LdOM"};